<template>
  <div class="overlay" v-if="active">
    <div class="modal">
      <div class="layout">
        <div class="item">
          <a
            href="#"
            class="btn navigation-icon close"
            v-on:click.prevent="active = false"
          ></a>

          <div class="wrapper">
            <a href="/" class="resmed-brand"></a>

            <div class="content text-center">
              <eyebrow-icon
                v-if="acf.eyebrowicon"
                v-bind:eyebrowicon="acf.eyebrowicon"
                v-bind:align="'center'"
              ></eyebrow-icon>
              <h2 v-html="acf.headline"></h2>
              <div v-html="acf.announcement"></div>
            </div>

            <div class="call-to-action">
              <a
                v-if="acf.cta[0]"
                v-bind:href="acf.cta[0].cta.href"
                v-bind:target="acf.cta[0].cta.target"
                class="btn cta-pill filled-red icon right-arrow mx-1"
                >{{ acf.cta[0].cta.text }}</a
              >
              <a
                v-if="acf.cta[1]"
                v-bind:href="acf.cta[1].cta.href"
                v-bind:target="acf.cta[1].cta.target"
                class="btn cta-pill hallow-red icon right-arrow mx-1"
                >{{ acf.cta[1].cta.text }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="backdrop"><!-- backdrop --></div>
  </div>
</template>

<script>
export default {
  name: "modal-announcement",
  props: ["acf"],
  data() {
    return {
      active: true,
      escapeListener: null,
    };
  },
  watch: {
    active(val) {
      document.body.style["overflow"] = val ? "hidden" : "visible";
    },
  },
  beforeDestroy() {
    window.removeEventListener(this.escapeListener);
  },
  created() {
    let date = new Date();
    date.setDate(date.getDate() + parseInt(this.acf.cookie.expires)); // expires in {this.cookie.expires} days
    date.toGMTString();

    document.cookie = `modal-announcement=1; expires=${date}; path=/`;

    this.escapeListener = window.addEventListener("keyup", (e) => {
      if (e.key === "Escape") {
        this.active = false;
      }
    });
  },
};
</script>

<style scoped lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/components/modal";
@import "../../css/base/typography";

.overlay {
  .layout {
    position: relative;
    background-color: $cc-resmed-white;
    margin: 5rem auto;
    width: 860px;
    max-width: 90vw;
    box-shadow: 0 2rem 3rem 0 rgba(0, 0, 0, 0.325);

    @media (min-height: 860px) {
      margin: 12rem auto;
    }

    .wrapper {
      padding: 2rem;

      @media (min-width: 768px) {
        padding: 3rem 6rem;
      }

      .resmed-brand {
        display: none;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center center;
        background-image: url(#{$assets}/images/logo-text-color.png);
        margin: 0 auto;

        @media (min-width: 576px) {
          display: block;
          width: 110px;
          height: 82px;
        }
      }
    }

    .content {
      margin: 4rem 0 2rem 0;

      h2 {
        position: relative;
        margin-bottom: 1rem;

        @extend %eyebrow-center;
      }
    }

    .call-to-action {
      text-align: center;
    }
  }
}
</style>